module.exports = __webpack_public_path__ + "static/media/4493 tops.e7b25c4a.JPG";